import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: "div" | "li" | "section" | "article";
};
export function Reveal({
  children,
  className,
  delay = 0,
  as = "div"
}: RevealProps) {
  const reduce = useReducedMotion();
  const Comp = motion[as];
  return <Comp className={className} initial={reduce ? false : {
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "-60px"
  }} transition={{
    duration: 0.28,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-478" data-mp="tf59q5kapap7">
      {children}
    </Comp>;
}